import { getUrlParam } from '../helpers/url';
import Services from '../pages/services/index.svelte';
import Service from '../pages/service/index.svelte';
import Form from '../pages/form/index.svelte';
import Thankyou from '../pages/thankyou/index.svelte';
function getPage(name) {
    let pages = {
        list: Services,
        details: Service,
        form: Form,
        thankyou: Thankyou,
    };
    return pages[name.toLowerCase()];
}
export function route() {
    let page = getUrlParam('page') || 'list';
    return getPage(page);
}
